import { useState } from "react";
import { RainforestSession } from "../../domain/invoicing/rainforest";

type RainforestStatus = 'LOADING' | 'READY'

const useRainforestComponents = (session: RainforestSession): RainforestStatus => {
  const [loadingState, setLoadingState] = useState<RainforestStatus | undefined>(window.rainforestLoadingState)

  if (loadingState !== undefined) {
    return loadingState
  }

  window.rainforestLoadingState = 'LOADING'

  const script = document.createElement('script')
  script.type = 'module'
  script.src = isSandbox(session) ? 'https://static.rainforestpay.com/sandbox.merchant.js' : 'https://static.rainforestpay.com/merchant.js'
  script.onload = () => {
    window.rainforestLoadingState = 'READY'
    setLoadingState?.('READY')
  }
  document.head.appendChild(script)

  return 'LOADING'
}

export default useRainforestComponents

const isSandbox = (session: RainforestSession): boolean => {
  return session.sessionKey.startsWith('sbx_')
}
